import md5 from "md5";

export function getHeaders() {
  let token = localStorage.getItem("token");
  let user = localStorage.getItem("user");
  let trick = localStorage.getItem("trick");
  return {
    headers: {
      'x-Authorization': md5(user + token),
      'x-Ref-Trick': parseInt(trick)
    }
  };
}
